/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 536
// module chunks = 0